import { render } from "./UltraCardService.vue?vue&type=template&id=0081fd1a&scoped=true"
import script from "./UltraCardService.vue?vue&type=script&lang=js"
export * from "./UltraCardService.vue?vue&type=script&lang=js"

import "./UltraCardService.vue?vue&type=style&index=0&id=0081fd1a&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/AcivgTheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0081fd1a"]])

export default __exports__